/**
 * Mapping de errores HTTP del backend a mensajes user-friendly en español (es-VE).
 * Inspirado en quorum-app/.../LoginViewModel.kt::mapLoginError.
 */
import { ApiError } from './api-client';
import type { ErrorCode } from '@formacion-docente/schemas';

export function mapApiError(e: unknown): string {
  if (e instanceof ApiError) {
    // Si el backend devuelve un mensaje personalizado, usarlo
    if (e.message) return e.message;
    if (e.status === 401) return 'Email o contraseña incorrectos.';
    if (e.status === 403) return 'Tu cuenta está desactivada. Contacta al administrador.';
    if (e.status === 404) return 'Recurso no encontrado.';
    if (e.status === 409) return 'Conflicto con datos existentes.';
    if (e.status === 410) return 'El enlace ha expirado o ya fue utilizado.';
    if (e.status === 422) return 'Operación no permitida por las reglas de negocio.';
    if (e.status === 429) return 'Demasiados intentos. Espera 15 minutos.';
    if (e.status >= 500) return 'Error del servidor. Intenta más tarde.';
    return 'Error inesperado.';
  }
  if (e instanceof TypeError) return 'Sin conexión. Verifica tu red.';
  return 'Error inesperado. Reintenta.';
}

const CODE_TO_MSG: Record<ErrorCode, string> = {
  invalid_input: 'Datos inválidos.',
  unauthenticated: 'Sesión expirada. Inicia sesión de nuevo.',
  forbidden: 'No tienes permisos para esta acción.',
  not_found: 'Recurso no encontrado.',
  conflict: 'Conflicto con datos existentes.',
  gone: 'El enlace ha expirado.',
  business_rule_violation: 'Operación no permitida por las reglas de negocio.',
  rate_limited: 'Demasiadas solicitudes. Espera unos minutos.',
  internal_error: 'Error interno del servidor.',
  dependency_unavailable: 'Servicio no disponible temporalmente.',
};

/** Mensaje amigable a partir del `code` semántico (ignora status). */
export function mapApiErrorByCode(code: ErrorCode): string {
  return CODE_TO_MSG[code] ?? 'Error inesperado.';
}